import type { IconProps } from './types';
import './icons.css';

export default function User({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      className={`icon icon-user ${className || ''}`}
    >
      <path
        stroke="currentColor"
        fill="none"
        d="M10 9.083a3.667 3.667 0 1 0 0-7.333 3.667 3.667 0 0 0 0 7.333zM2.667 18.25v-3.667c0-1.012.82-1.833 1.833-1.833h11c1.012 0 1.833.82 1.833 1.833v3.667"
      />
    </svg>
  );
}
